export default __webpack_public_path__ + "images/4e43d2c86af2afd659ec8c64f9a630a3-app_preview.png";